import { ComponentAPI } from '@philips-internal/oswald-ui-core';
export default class CardAppointmentsTitleAPI extends ComponentAPI {
    setShowSubtitle(showSubTitle) {
        this.setState({ showSubTitle });
    }
}
//# sourceMappingURL=card-appointments-title-api.js.map